import { fetchClient } from "@/api/api";
import type {
	getAdminPlayersInput,
	getAdminPlayersOutput,
} from "@/api/custom_types";
import type { ApiError } from "@/utils/fetching";
import type { CustomQueryHook } from "@/utils/react-query";
import { useQuery } from "@tanstack/react-query";
import { ADMIN_PLAYERS_SERVICE_KEYS } from "./keys";

export const useGetAdminPlayers: CustomQueryHook<
	getAdminPlayersOutput,
	getAdminPlayersInput
> = (params, options) => {
	return useQuery<getAdminPlayersOutput, ApiError>({
		...options,
		queryKey: ADMIN_PLAYERS_SERVICE_KEYS.useGetAdminPlayers(params ?? {}),
		queryFn: async () => {
			const { data, error } = await fetchClient.GET("/v1/fc/admin/players/", {
				params: { query: params ?? {} },
				throwOnError: true,
			});
			if (error) throw error;
			return data;
		},
	});
};
